export const AMOUNT = 0;
export const PERCENTAGE = 1;
